import React from 'react'
import {
  Box, Button,
  Card,
  styled,

} from '@mui/material';
import { Table } from 'antd';
import { useOrderStatusListById } from '../../../requests/dashboard';

import {
  useParams
} from "react-router-dom"
import moment from 'moment';

const CardHeader = styled(Box)(() => ({
  display: 'flex',
  paddingLeft: '24px',
  paddingRight: '24px',
  marginBottom: '12px',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const Title = styled('span')(() => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize',
}));


function getStatus(event) {
  return String(event).split("_").join(" ");
}

const OrderStatus = () => {

  const { id } = useParams();

  const {
    data: orderStatusList,
  } = useOrderStatusListById({
    order_id: id
  });


  const columns = [
    {
      title: 'Date time',
      dataIndex: '_date',
      key: '_date',
      render: _date => moment(_date).format('DD-MM hh:mm a')
    },
    {
      title: 'Status',
      dataIndex: 'event',
      key: 'event',
      render: event => getStatus(event)
    },
  ];



  return (
    <div>

      <Card elevation={3} sx={{ pt: '20px', mb: 3 }}>
        <CardHeader>
          <Title>Order Status History </Title>
        </CardHeader>

        <Table
          pagination={false}
          dataSource={orderStatusList || []}
          columns={columns}
        />;


      </Card>


    </div>
  )
}

export default OrderStatus